const CUSTOM_EVENT = 'customEvent';

const ACTIONS = {
  MESSAGE_FROM_CHILD_APP: 'messageFromChildApp',
};

const TRACKING_CONTENT_REGION_NAME = {
  SiteGlobalSwitch: 'SiteGlobalSwitch',
  NotificationBell: 'NotificationBell',
  NotificationModal: 'NotificationModal',
};

const TRACKING_CONTENT_NAME = {
  OpenSiteSwitchDropdown: 'OpenSiteSwitchDropdown',
  SelectSite: 'SelectSite_',
  CommandPaletteSearch: 'CommandPaletteSearch',
  CommandPaletteToggle: 'CommandPaletteToggle',
  // Push notification flow
  NotificationReceived: 'NotificationReceived',
  OpenNotificationBell: 'OpenNotificationBell',
  NotificationItem: 'NotificationItem',
  NotificationDeeplink: 'NotificationDeeplink',
  MarkAllRead: 'MarkAllRead',
  ViewAllNotification: 'ViewAllNotification',
};

export default {
  CUSTOM_EVENT,
  ACTIONS,
  TRACKING_CONTENT_REGION_NAME,
  TRACKING_CONTENT_NAME,
};
